import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Dziś',
    [filter_yesterday]: 'Wczoraj',
    [filter_this_week]: 'Ten tydzień',
    [filter_last_week]: 'Ostatni tydzień',
    [filter_this_month]: 'Ten miesiąc',
    [filter_last_month]: 'Ostatni miesiąc',
    [filter_last_30_days]: 'Ostatnie 30 dni',
    [filter_all]: 'Wszystkie',
  },
};
